export const CCPA_ANALYTICS = 'floracal_ccpa_analytics';
export const ACCESSIBILITY = 'floracal_accessibility';
